export default {
  email: {
    id: 0,
    estado: '',
    placa: '',
    placaValido: false,
    placaCompleta: false,
    cor: 'AMARELA',
    modelo: '',
    nome: '',
    empresa: '',
    email: '',
    telefone: ''
  },
  buscaremails: {}
  
}